import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import getEither from '../../core/util/getEither';
import PreorderModeContext from '../../preorder/PreorderModeContext';
import { useProductListOptionsContext } from '../components/ProductList/context/ProductListOptionsContext';
import useDefaultSorting from '../queries/useDefaultSorting';

const useProductListQueryFilters = () => {
    const { productsFilters } = useContext(PreorderModeContext);

    const params = useParams<{
        page: string;
    }>();

    const {
        filters: {
            store,
            language,
            categoryId,
            minPrice,
            maxPrice,
            vehicleId,
            bicycleId,
            pageSize,
            sortField,
            sortOrder,
            states,
            filters,
            search,
            preorderSeasonId,
            includePreorderSeasonId,
            rootCategoryId,
            includeExcludedCategories,
            bestAvailability,
            attributeFilters,
        },
        isFiltersLoading: skip,
    } = useProductListOptionsContext();

    const { defaultSorting, loading: defaultSortLoading } = useDefaultSorting();

    const skipLoadingWhileDefaultSortingLoading =
        !sortField && defaultSortLoading;

    return {
        ...productsFilters,
        store,
        language,
        pageSize: pageSize,
        page: +getEither(params.page, 1),
        states: states,
        categoryId,
        sortField: getEither(sortField, defaultSorting[0]),
        sortDirection: getEither(sortOrder, defaultSorting[1]),
        filters,
        minPrice,
        maxPrice,
        vehicleId,
        bicycleId,
        search,
        preorderSeasonId,
        includePreorderSeasonId,
        rootCategoryId,
        skipLoadingWhileDefaultSortingLoading,
        skip,
        includeExcludedCategories,
        bestAvailability,
        attributeFilters,
    };
};

export default useProductListQueryFilters;
